import type { CasingStyle } from "@rubi/api-generated/clientRs/types.gen";

// Casing options for normalizing dropdown item labels. `style` matches the backend
// CasingStyle enum; `example` shows the effect on a sample label. Shared between the
// single-list editor (ItemTypeOptionView) and the main-page bulk-edit modal so the two
// stay in sync.
export const CASING_OPTIONS: {
  style: CasingStyle;
  label: string;
  example: string;
}[] = [
  { style: "uppercase", label: "Uppercase", example: "NORTH WEST" },
  { style: "titleCase", label: "Title Case", example: "North West" },
  { style: "firstLetterCapital", label: "First Letter", example: "North west" },
];

export const CASING_LABELS: Record<CasingStyle, string> = {
  uppercase: "Uppercase",
  titleCase: "Title Case",
  firstLetterCapital: "First Letter",
};
